import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import { date, invoiceTotal, money } from '../shared/formatters';
import KeyDateList from '../shared/components/KeyDateList';
import StatusPill from '../shared/components/StatusPill';
import PortalHeader from './PortalHeader';
import RequestJob from './RequestJob';

export default function Dashboard() {
  const { data } = useData();
  const { client, base } = usePortalClient();
  const clientInvoices = data.invoices.filter((item) => item.client_id === client.id);
  const clientDates = data.keyDates
    .filter((item) => item.client_id === client.id)
    .sort((a, b) => new Date(a.date) - new Date(b.date));
  const clientMessages = data.messages.filter((item) => item.client_id === client.id);
  const visibleNotes = data.notes
    .filter((item) => item.client_id === client.id && item.client_visible)
    .sort((a, b) => Number(b.pinned) - Number(a.pinned) || new Date(b.created_at) - new Date(a.created_at));
  const latestInvoice = clientInvoices.at(-1);
  const latestMessage = clientMessages.at(-1);

  return (
    <>
      <PortalHeader
        eyebrow="Your home portal"
        title={`Hello, ${client.name.split(' ')[0]}`}
        description="Your appointments, invoices, and property records in one place."
      />

      <div className="portal-summary">
        <section className="highlight-card">
          <span className="eyebrow">Next key date</span>
          <h2>{clientDates[0]?.title || 'Nothing scheduled'}</h2>
          <p>{clientDates[0] ? date(clientDates[0].date) : 'We will let you know when this changes.'}</p>
          <Link to={`${base}/keydates`}>View key dates</Link>
        </section>

        {visibleNotes.length > 0 && (
          <section className="portal-card notes-card">
            <span className="eyebrow">Notes from your engineer</span>
            <blockquote>“{visibleNotes[0].body}”</blockquote>
            <small>{visibleNotes[0].author || 'Your engineer'} · {date(visibleNotes[0].created_at)}</small>
            {visibleNotes.length > 1 && <small>{visibleNotes.length - 1} more note{visibleNotes.length > 2 ? 's' : ''}</small>}
          </section>
        )}

        <section className="portal-card">
          <div className="card-top">
            <span className="eyebrow">Latest invoice</span>
            {latestInvoice && <StatusPill invoice={latestInvoice} />}
          </div>
          <h2>{latestInvoice ? money(invoiceTotal(latestInvoice)) : '£0.00'}</h2>
          <p>{latestInvoice ? `${latestInvoice.number} · Due ${date(latestInvoice.due_date)}` : 'No invoices yet'}</p>
          <Link to={`${base}/invoices`}>View invoices</Link>
        </section>

        <section className="portal-card">
          <span className="eyebrow">Latest message</span>
          <blockquote>{latestMessage ? `“${latestMessage.body}”` : 'No messages yet.'}</blockquote>
          <Link to={`${base}/chat`}>Open conversation</Link>
        </section>
      </div>

      <div className="portal-section-head">
        <div>
          <span className="eyebrow">Stay prepared</span>
          <h2>Coming up</h2>
        </div>
      </div>

      <section className="portal-card no-padding">
        <KeyDateList dates={clientDates.slice(0, 3)} />
      </section>

      <RequestJob />
    </>
  );
}
